<template>
  <div class="topbar">
    <div class="row">
      <!-- <iframe id="redir" src width="1px" height="1px"></iframe> -->
      <div class="action-left">
        <span @click="toggleLang('en_US')" :class="{ 'active': lang === 'en_US' }"> English</span> |
        <span @click="toggleLang('zh_CN')" :class="{ 'active': lang === 'zh_CN' }"> 简体中文</span> |
        <span @click="toggleLang('zh_TW')" :class="{ 'active': lang === 'zh_TW' }"> 繁體中文 </span>
        <span style="margin-left: 10px;">中文域名：海南涉外民商事法庭案件多元化解平台.政务</span>
      </div>
      <div class="action-right">
        {{ $t('home.hello') }}
        <label v-show="islogin">
          <a href="/userCenter/center/first" @click="goCenter">
            <span class="showname">{{ isRealName ? username : mobilephone }}</span>
          </a>

          <span class="split"></span>
          <a href @click.prevent="loginout">{{ $t('home.exit') }}</a>
          <p class="phone" @mouseover="isshowapplet = true" @mouseout="isshowapplet = false">
            {{ $t('footer.smallProgram') }}
            <img v-show="isshowapplet" src="@/module/home/img/qrcode.jpg" alt="海南涉外民商事法庭案件多元化解平台小程序">
          </p>
          <!-- <a href @click.prevent="tolink">诉讼服务</a> -->
          <!-- <span class="split"></span>
          <a href="#">帮助中心</a>-->
        </label>
        <label v-show="!islogin">
          {{ $t('home.please') }}
          <a href="/useraction/login">{{ $t('home.login') }}</a>
          <span class="split"></span>
          <!--<a href="/useraction/register">注册</a>-->
          <p class="phone" @mouseover="isshowapplet = true" @mouseout="isshowapplet = false">
            {{ $t('footer.smallProgram') }}
            <img v-show="isshowapplet" src="@/module/home/img/qrcode.jpg" alt="海南涉外民商事法庭案件多元化解平台小程序">
          </p>
          <!-- <a href @click.prevent="tolink">诉讼服务</a> -->
          <!-- <span class="split"></span>
          <a href="#">帮助中心</a>-->
        </label>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getStore,
  removeStore
} from '@/publicResource/utils/utils.js'
import { logoutOptions } from '@/publicResource/api/apiSetting.js'
import { setTimeout } from 'timers'
export default {
  data() {
    return {
      isshowapplet: false,
      islogin: false,
      mobilephone: '',
      username: '',
      headUrl: '',
      isRealName: false,
      lang: ''
    }
  },
  mounted() {
    this.lang = localStorage.getItem('locale')
    let logininfo = JSON.parse(getStore('loginInfouser'))
    if (logininfo) {
      if (logininfo.userInfo.headPortraitUrl) {
        this.headUrl = logininfo.userInfo.headPortraitUrl
      }
      if (logininfo.userInfo.isRealName) {
        this.isRealName = true
        this.username = logininfo.userInfo.userName
      }
      if (!logininfo.userInfo.mobilePhone) {
        let userName = logininfo.userInfo.userName
        this.mobilephone = userName.substr(0, 3) + '****' + userName.substr(-4, 4)
      } else {
        let phone = logininfo.userInfo.mobilePhone
        this.mobilephone = phone.substr(0, 3) + '****' + phone.substr(7, 4)
      }
      this.islogin = true
    }
  },
  methods: {
    // 语言
    toggleLang(lang) {
      if (lang === 'zh_CN') {
        localStorage.setItem('locale', 'zh_CN')
        this.lang = localStorage.getItem('locale')
        this.$message({
          message: '切换为中文！',
          type: 'success'
        })
      } else if (lang === 'en_US') {
        localStorage.setItem('locale', 'en_US')
        this.lang = localStorage.getItem('locale')
        this.$message({
          message: 'Switch to English!',
          type: 'success'
        })
      } else if (lang === 'zh_TW') {
        localStorage.setItem('locale', 'zh_TW')
        this.lang = localStorage.getItem('locale')
        this.$message({
          message: '切換為中文！',
          type: 'success'
        })
      }
      window.location.reload()
    },
    tolink() {
      //                let logininfo = JSON.parse(getStore("loginInfouser"));
      //                let linkurl = "";
      //                if (logininfo) {
      /// /        linkurl = "/userCenter/center/third";
      //                    linkurl = "https://www.gzinternetcourt.gov.cn";
      //                } else {
      //                    setStore("tolink", "/userCenter/center/third");
      /// /        linkurl = "/useraction/login";
      //                    linkurl = "https://www.gzinternetcourt.gov.cn";
      //                }
      window.location.href = 'https://www.gzinternetcourt.gov.cn'
    },
    goCenter() {
      sessionStorage.clear()
    },
    loginout() {
      if (getStore('dddddd')) {
        logoutOptions().then(
          res => {
            removeStore('authToken')
            removeStore('refreshToken')
            removeStore('loginInfouser')
            removeStore('dddddd')
            this.islogin = false
            const redir = document.getElementById('redir')
            redir.setAttribute(
              'src',
              'https://www.gzinternetcourt.gov.cn/oauth/logout.do'
            )
            setTimeout(() => {
              window.location.href = '/home.html'
            }, 3000)
          },
          erro => {
            this.$message.error(erro)
          }
        )
      } else {
        logoutOptions().then(
          res => {
            removeStore('authToken')
            removeStore('refreshToken')
            removeStore('loginInfouser')
            this.islogin = false
            window.location.href = '/home.html'
          },
          erro => {
            this.$message.error(erro)
          }
        )
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.topbar {
  background-color: #ececec;
  height: 30px;
  line-height: 30px;

  .action-left {
    float: left;

    span {
      color: #9b9999;
      cursor: pointer;
      display: inline-block;
      font-size: 14px;

      &:hover {
        color: #666;
      }

      &.active {
        color: #3595f4;
      }
    }
  }

  .action-right {
    float: right;
    font-size: 14px;
    color: #888;

    a {
      color: #888;
      padding: 0 5px;
    }

    .split {
      width: 1px;
      height: 9px;
      background-color: #ccc;
      display: inline-block;
    }

    .phone {
      padding: 0 5px;
      cursor: pointer;
      background: url(../../module/home/img/icon_phone.png) no-repeat 5px center;
      padding-left: 20px;
      position: relative;
      display: inline-block;

      img {
        position: absolute;
        right: -30px;
        top: 28px;
        background-color: #fff;
        padding: 0px;
        z-index: 10;
        width: 110px;
        height: 110px;
        padding: 10px;
        border: 1px solid #e6e6e6;
        border-radius: 4px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/publicResource/components/topbar.vue